import { tv } from 'tailwind-variants';

import { base } from './base';

import type { ComponentPropsWithRef } from 'react';
import type { VariantProps } from 'tailwind-variants';

const heading = tv({
  extend: base,
  base: 'font-aeonik',
  variants: {
    size: {
      lg: 'text-[2rem] leading-9.5',
      md: 'text-[1.5rem] leading-8',
      sm: 'text-[1.25rem] leading-7',
      xs: 'text-[1rem] leading-5 tracking-[-1%]',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export type HeadingVariants = VariantProps<typeof heading>;

const SIZE_TO_ELEMENT = {
  lg: 'h3',
  md: 'h4',
  sm: 'h5',
  xs: 'h6',
} as const;

const LEVEL_TO_ELEMENT = {
  2: 'h2',
  3: 'h3',
  4: 'h4',
  5: 'h5',
  6: 'h6',
} as const;

type HeadingLevel = 2 | 3 | 4 | 5 | 6;
type HeadingElement = (typeof SIZE_TO_ELEMENT)[keyof typeof SIZE_TO_ELEMENT] | 'h2';
type HeadingProps = ComponentPropsWithRef<'h3'> & HeadingVariants & { level?: HeadingLevel };

function Heading({ className, level, size = 'md', weight, italic, disabled, tracking, ...rest }: HeadingProps) {
  const Element: HeadingElement = level ? LEVEL_TO_ELEMENT[level] : SIZE_TO_ELEMENT[size];
  return <Element className={heading({ size, weight, italic, disabled, tracking, class: className })} {...rest} />;
}

export { heading, Heading };
